import axios from "axios";
import config from "./config";

const UpdateMarket = async (id, payload) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_API}/api/market/UpdatePrice/${id}`,
      payload,
      config()
    );
    return { status: 200, payload: data };
  } catch (error) {
    return handleError(error);
  }
};

const handleError = (error) => {
  if (error.response) return { status: error.response.status, payload: null };
  return { status: 500, payload: null };
};

export default UpdateMarket;
